<div [class.container-wide]="!isModal" style="height: 100%">
    <div [class.single-column-layout]="!isModal" [hidden]="selectedTransmittalID">
        @if (companyName) {
            <div class="entity-header">
                <ol class="breadcrumb float-start" style="background-color: initial">
                    <li class="breadcrumb-item">
                        <a class="pointer" (click)="navigateToCompany()">{{ companyName }}</a>
                    </li>
                </ol>
                <div class="clearfix"></div>
            </div>
        }
        <div>
            <h1 class="float-start mt-4" style="font-family: 'Oswald'">Bill Payment Packages</h1>
            @if (finalizing) {
                <div>
                    <div class="clearfix"></div>
                    <div class="text-center" style="margin-top: 50px">
                        <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
                        <span class="spinner-label-text">
                            @if (!finalizeLoadingMessage) {
                                <span>Finalizing...</span>
                            }
                            @if (finalizeLoadingMessage) {
                                <span>{{ finalizeLoadingMessage }}</span>
                            }
                            <br />
                            @if (!processingCancelled && !hideCancelHyperlink) {
                                <span class="anchor-style" (click)="processingCancelled = true">(Cancel)</span>
                            }
                            @if (processingCancelled) {
                                <span>Cancelling Remaining Packages...</span>
                            }
                        </span>
                    </div>
                </div>
            }
            <div [style.visibility]="finalizing ? 'hidden' : 'visible'">
                @if (readOnly && !isModal && showDates) {
                    <div class="d-flex align-items-center float-end mt-4">
                        <label class="text-nowrap me-2 mb-0">Sent Range: </label>
                        <div class="input-group">
                            <weissman-datetime
                                [(inputDate)]="startDate"
                                [dateOnly]="true"
                                [timeZone]="'Central'"
                                #startDatePicker
                            >
                            </weissman-datetime>
                        </div>
                        <span class="mx-2">to</span>
                        <div class="input-group">
                            <weissman-datetime
                                [(inputDate)]="endDate"
                                [dateOnly]="true"
                                [timeZone]="'Central'"
                                [rangeEnd]="true"
                                #endDatePicker
                            >
                            </weissman-datetime>
                        </div>
                        <button class="ace-btn btn-sm btn-primary" (click)="refreshList()"> Refresh </button>
                    </div>
                }
                <div class="clearfix"></div>
                @if (loading) {
                    <div class="text-center" style="margin-top: 50px">
                        <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
                    </div>
                }
                @if (!loading && paymentPackages?.length > 0) {
                    <payment-packages-table
                        #paymentPackagesTable
                        [paymentPackages]="paymentPackages"
                        [readOnly]="readOnly"
                        [isModal]="isModal"
                        [isPrelimApFeed]="isPrelimApFeed"
                        [isFromPaymentBatch]="isFromPaymentBatch"
                        (showDetails)="showDetails($event)"
                        (loading)="loading = $event"
                        (showSaveButton)="showSaveButton = $event"
                    >
                    </payment-packages-table>
                }
                @if (paymentPackages?.length === 0) {
                    <div>
                        <h3 style="text-align: center">No payment packages</h3>
                    </div>
                }
                @if (!readOnly) {
                    <div class="ws-button-row">
                        @if (getCompletePackageCount() < paymentPackages?.length) {
                            <button class="ace-btn btn-primary btn-danger" (click)="cancelPackages()"> Cancel </button>
                        }
                        @if (getCompletePackageCount() === paymentPackages?.length) {
                            <button class="no-bubble ace-btn btn-primary" (click)="returnToActionView()">
                                {{ returnButtonText }}
                            </button>
                        }
                        @if (showSaveButton) {
                            <button class="ace-btn btn-primary btn-success" (click)="finalizePackages()">
                                {{ saveButtonText }}
                            </button>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
    @if (selectedTransmittalID) {
        <transmittal-details
            [selectedPackage]="selectedPackage"
            [selectedTransmittalID]="selectedTransmittalID"
            [readOnly]="readOnly"
            [isModal]="isModal"
            [shouldReturnToPaymentBatch]="shouldReturnToPaymentBatch"
            (backClicked)="backClicked()"
        >
        </transmittal-details>
    }
    <finalize-payment-package-modal
        [packageList]="paymentPackages"
        [cancelExecutionLoop]="processingCancelled"
        (hasPackageFinalized)="packageFinalized()"
        [setParentLoading]="setFinalizeLoading"
        [isFromPaymentBatch]="isFromPaymentBatch"
        [paymentBatchId]="paymentBatchId"
        [taskId]="taskId"
        #FinalizePaymentPackageModal
    >
    </finalize-payment-package-modal>
</div>
